import { useTranslation } from "react-i18next";
import Title from "../../components/Title/Title";
import PageWrapper from "../PageWrapper/PageWrapper";

const PrivacyPolicyPage = () => {

  const { t } = useTranslation("privacy");
  const privacySections = [
    'privacy_section1', 'privacy_section2', 'privacy_section3', 'privacy_section4', 'privacy_section5', 
    'privacy_section6', 'privacy_section7', 'privacy_section8', 'privacy_section9', 'privacy_section10', 
    'privacy_section11', 'privacy_section12', 'privacy_section13', 'privacy_section14', 'privacy_section15', 
    'privacy_section16'
  ];

  return (
    <PageWrapper>
      <>
        <Title text={t("menu.privacy_policy")} />
        {privacySections.map((key) => (
          <div className="pt-5 pb-5" key={key} dangerouslySetInnerHTML={{ __html: t(key) }} />
        ))}
      </>
    </PageWrapper>
  );
}

export default PrivacyPolicyPage;
